import { isBlank as i } from "../../strings/utils.js";
const p = (o) => o ?? void 0, f = (o) => o, l = () => {
}, r = (o) => o == null, s = (o) => !r(o), c = (o) => s(o) && !i(o), m = (o) => !c(o), d = (...o) => o.some(s), y = (o, t) => s(o) && s(t) && o !== t, a = (o, t) => s(o) ? o : t(), h = (o, t) => s(o) ? t(o) : void 0, E = (o, t) => s(o) ? t(o) : void 0, g = (o, t, n) => s(o) ? t(o) : n(), k = (o) => s(o) ? [o] : [], B = (o) => o.filter(s), M = (o) => s(o) && o.length > 0 ? o : void 0, N = async (o, t) => Promise.resolve(o).then((n) => s(n) ? t(n) : void 0), O = async (o, t) => Promise.resolve(o).then((n) => s(n) ? t(n) : void 0), A = (o) => o.length > 0 ? o[0] : void 0, x = (o) => {
  if (!r(o) && !(typeof o == "string" && i(o)))
    return o;
};
export {
  k as asArray,
  O as asyncFlatMap,
  N as asyncMap,
  h as fMap,
  B as filterNotNull,
  A as firstIfExists,
  E as flatMap,
  a as getOrElse,
  d as hasSome,
  s as hasValue,
  r as isEmpty,
  m as isEmptyOrBlank,
  c as isNotEmptyOrBlank,
  g as mapOrElse,
  M as nonEmptyArray,
  l as none,
  p as optional,
  f as some,
  x as stripNullishBlank,
  y as valuesAreDifferent
};
//# sourceMappingURL=utils.js.map
